import ScrollBar from "react-perfect-scrollbar";
import { Card, CardBody, Col, Row } from "reactstrap";
import { Image } from "../../../../AbstractElements";
import { horizontalScrollSubTitle } from "../../../../Data/BonusUi/Scrollable";
import { dynamicImage, dynamicNumber } from "../../../../Utils";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import { HorizontalScrollbarTitle } from "../../../../Utils/Constants";

export default function HorizontalScrollbar() {
  return (
    <Col xl={6}>
      <Card>
        <CommonCardHeader headClass="pb-0" title={HorizontalScrollbarTitle} subTitle={horizontalScrollSubTitle} />
        <CardBody>
          <ScrollBar className="scrollbar-container horizontal-scroll scroll-demo " style={{ width: "100%", height: "300px" }}>
            <div className="horz-scroll-content scroll-content-width">
              <Row>
                {dynamicNumber(6).map((item, index) => (
                  <Col xs={2} key={index}>
                    <div className="horizontal-img">
                      <Image className="img-fluid" src={dynamicImage(`scrollbar/fashion${item}.jpg`)} alt="girl" />
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </ScrollBar>
        </CardBody>
      </Card>
    </Col>
  );
}
